/* COMPONENT IMPORTS*/
import { ErrorPage } from "../../components/ErrorPage/ErrorPage";
import { ReactPlugin, withAITracking } from "@microsoft/applicationinsights-react-js";
import ContextConstructor from "../../components/Context/Context";
import MGModalityHeader from "../../components/MGModalityHeader/MGModalityHeader";
import MGMyModalities from "../../components/MGMyModalities/MGMyModalities";
import MGModalitySubscription from "../../components/MGModalityCardsSubscription/MGModalitySubscription";
import { getPublicURL } from "../../env";

/* MODULE IMPORTS */

import React, { Component } from "react";

/* SAME FOLDER IMPORTS*/
import sendLogError from "../../sendLogError";
import { MGModalityStep } from "../../utils/MGModalityStep";
import MGMySubscriptions from "../../components/MGMySubscriptions/MGMySubscriptions";
import { MGMySubscriptionDetailCardType } from "../../components/MGMySubscriptions/MGMySubscriptionDetailCardType";


/* CSS IMPORT */
import "./ProtecaoPoupanca.css";
import "../../components/Loading/loading.css";

//Imagem
import loading from "../../images/loading.svg";
import { ArrowLeft } from 'lucide-react';
import protecao from "../../images/Modality/protecaopoupanca.svg"

const pageid = "14597";
var reactPlugin = new ReactPlugin();

class ProtecaoPoupanca extends Component {
    static displayName = ProtecaoPoupanca.name;

    constructor(props) {
        super(props);
        this.state = {
            protecao: [],
            error: [],
            loading: true,
            step: MGModalityStep.DASHBOARD,
            item: ""
        };
    }

    componentDidMount() {
        if (
            this.context.selectedUserID !== "" &&
            this.context.selectedUserID !== undefined &&
            this.context.selectedUserID !== null
        ) {
            this.populateProtectionData();
        }
    }

    errorLoadingPortfolio() {
        return (
            <div>
                <ErrorPage />
            </div>
        );
    }

    handleBack() {
        if (window.history.length > 1) {
            window.history.back();
        } else {
            window.history.replaceState(null, "", "/");
        }
    }

    transformActives(a) {
        if (a == "1") return a + " subscrição ativa";
        else return a + " subscrições ativas";
    }

    renderProtectionData(state) {
        return (
            <div>
                <main className="Protecao-main">
                    <MGModalityHeader
                        subscriptionActivity={this.transformActives(state.protecao.subscriptionsNumber)}
                        icon={protecao}
                        title={'Poupança + Proteção'}
                        leftTitle={"Capital Subscrito"}
                        leftAmount={new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(state.protecao.totalAmounts.totalCurrentAmount)}
                        rightTitle={"Entrega periódica"}
                        rightAmount={new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(state.protecao.totalAmounts.totalPaidAmount)} />
                    <MGMyModalities
                        myModalities={state.protecao}
                        leftTitle={"Capital Subscrito"}
                        rightTitle={"Entrega periódica"}
                        onClick={(key) => {
                            this.setState({ step: MGModalityStep.DETAIL, item: key })
                        }}
                    />
                    <MGModalitySubscription id={"3"} context={this.context} myModalities={state.protecao.productTypes} publicURL={getPublicURL()} />
                </main>
            </div>
        );
    }

    renderProtectionDetail(state) {
        const { productName, subscriptionsNumber, totalAmounts, subscriptions } = this.filterProtectionList(state);
        return (
            <div>
                <header className="Savings-header">
                    <ArrowLeft onClick={() => { this.setState({ step: MGModalityStep.DASHBOARD, item: "" }) }} />
                    Voltar a Poupança + Proteção
                </header>
                <main className="Savings-main">
                    <MGModalityHeader
                        subscriptionActivity={this.transformActives(subscriptionsNumber)}
                        icon={protecao}
                        title={productName}
                        leftTitle={"Capital Subscrito"}
                        leftAmount={new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(totalAmounts.totalCurrentAmount)}
                        rightTitle={"Entrega periódica"}
                        rightAmount={new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(totalAmounts.totalPaidAmount)} />

                    <MGMySubscriptions mySubscriptions={subscriptions} subscriptionDetailCardType={MGMySubscriptionDetailCardType.PROTECTION} />
                </main>
            </div>
        );
    }

    filterProtectionList(state) {
        return state.protecao.productTypes.find((i) => (i.productID === state.item))
    }

    renderPage(state) {
        switch (state.step) {
            case MGModalityStep.DASHBOARD:
                return this.renderProtectionData(this.state)
            case MGModalityStep.DETAIL:
                return this.renderProtectionDetail(state);
            default:
                return this.renderPortfolioData(state);
        }
    }

    render() {
        let contents = this.state.loading ? (
            <div className="main-page-loading">
                <div className="loading">
                    <img src={loading}></img>
                </div>
            </div>
        ) : this.state.error ? (
            this.errorLoadingPortfolio()
        ) : (
            <div className="main">
                {this.renderPage(this.state)}
            </div>
        );

        return <>{contents}</>;
    }

    async populateProtectionData() {
        try {
            const { idToken, selectedUserID } = this.context;

            const headers = {
                Authorization: `Bearer ${idToken}`,
                clientId: selectedUserID,
            };

            const response = await fetch("/Portfolio/GetPortfolio", { headers });

            if (!response.ok) {
                this.setState({
                    error: false,
                    protecao: {},
                    loading: false,
                });

                return;
            }

            const data = await response.json();

            this.setState({
                error: false,
                protecao: data.savingsPlusProtection || {},
                loading: false,
            });

        } catch (error) {
            console.error("Error fetching protection data:", error);

            this.setState({
                error: true,
                loading: false,
                protecao: {},
            });

            sendLogError(error.message, "populateProtectionData");
        }
    }
}

ProtecaoPoupanca.contextType = ContextConstructor;

export default withAITracking(reactPlugin, ProtecaoPoupanca);
